import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {BlobStorageUploadJob} from '../models/file.model';

export interface IActionReasonAction {
  action?: string;
  buttonClicked?: 'confirm' | 'cancel' | string;
  comment?: string;
  attachments?: Promise<BlobStorageUploadJob[]>;
}

@Injectable({
  providedIn: 'root'
})
export class ActionsReasonService {
  private currentAction = '';
  private currentPosition = '';
  private mainButtonTitle = 'confirm';
  private isRequired = false;

  private actionReason: Subject<IActionReasonAction> = new Subject<{action: string; comment?: string}>();

  public setAction(action: string): void {
    this.currentAction = action;
    this.mainButtonTitle = '';
  }
  public setPosition(position: string): void {
    this.currentPosition = position;
  }
  public setMainButtonTitle(title: string): string {
    this.mainButtonTitle = title;
    return this.mainButtonTitle;
  }
  public setIsRequired(isRequired: boolean): void {
    this.isRequired = isRequired;
  }
  public getAction(): string {
    return this.currentAction;
  }
  public getPosition(): string {
    return this.currentPosition;
  }
  public getMainButtonTitle(): string {
    return this.mainButtonTitle ? this.mainButtonTitle : 'confirm';
  }
  public getIsRequired(): boolean {
    return this.isRequired;
  }

  public cancelAction(): void {
    this.actionReason.next({action: this.currentAction, buttonClicked: 'cancel'});
    this.setAction('');
  }

  public confirmAction(comment: string, attachments: Promise<BlobStorageUploadJob[]> = null): void {
    this.actionReason.next({action: this.currentAction, buttonClicked: 'confirm', comment, attachments});
    this.setAction('');
  }

  public getReason(): Observable<IActionReasonAction> {
    return this.actionReason.asObservable();
  }
}
